// Disclosures work without JavaScript and after theme-editor section reloads.
document.addEventListener(
  "toggle",
  (event) => {
    const disclosure = event.target;
    if (!(disclosure instanceof HTMLDetailsElement) || !disclosure.open) return;
    if (disclosure.matches(".nav-item > details, .header-search, .mobile-nav")) {
      document
        .querySelectorAll(".nav-item > details[open], .header-search[open], .mobile-nav[open]")
        .forEach((other) => {
          if (other !== disclosure) other.open = false;
        });
    }
    if (disclosure.matches(".header-search")) disclosure.querySelector("input")?.focus();
  },
  true,
);
document.addEventListener("keydown", (event) => {
  if (event.key !== "Escape") return;
  const focused = document.activeElement?.closest("details[open]");
  const disclosure =
    focused || document.querySelector(".site-header details[open]");
  if (disclosure) {
    disclosure.open = false;
    disclosure.querySelector("summary")?.focus();
  }
});
document.addEventListener("click", (event) => {
  if (!event.target.closest(".site-header")) {
    document.querySelectorAll(".site-header details[open]").forEach((item) => {
      item.open = false;
    });
  }
});

function updateHeader() {
 document.querySelectorAll('.site-header').forEach(header => header.classList.toggle('is-scrolled', window.scrollY > 24));
}
window.addEventListener('scroll', updateHeader, {passive:true});
document.addEventListener('shopify:section:load', updateHeader);
updateHeader();
